import { Hotspot } from "../../../../Types";
import { Link } from "../../../Icons/left-side-bar-icons";

function linkCheck(url: string): string {
  if (url.startsWith("http") || url.startsWith("https")) {
    return url;
  } else {
    return "https://" + url;
  }
}

function ViewerLink({ link, zoom }: { link: Hotspot; zoom: number }) {
  return (
    <div tooltip-text={link.title || ""} className="viewer-exp-icon">
      <a
        href={linkCheck(link.target as string)}
        target="_blank"
        rel="noreferrer"
      >
        <Link
          style={{ opacity: ((zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1 }}
          className="viewer-exp-elem"
          fill={"white"}
          width="4em"
          height="4em"
          stroke={"#222"}
          strokeWidth="25px"
        />
      </a>
    </div>
  );
}

export default ViewerLink;
